module.exports = __webpack_public_path__ + "files/d5b298b2759a865ada2338f3392d3eac.png";